<div class="peek-header">
  <div class="peek-header-top">
    <span class="peek-title">{{ title() }}</span>
    <ng-content select="[peekStatus]"></ng-content>
    <div class="peek-header-actions">
      <sh-button
        *ngIf="expandable()"
        type="button"
        variant="text"
        [rounded]="true"
        icon="pi pi-window-maximize"
        ariaLabel="shell.peek.expand"
        shTooltip="shell.peek.expand"
        tooltipPosition="bottom"
        (click)="expand.emit()"
      ></sh-button>
      <sh-button
        type="button"
        variant="text"
        [rounded]="true"
        icon="pi pi-times"
        ariaLabel="shell.peek.close"
        (click)="close.emit()"
      ></sh-button>
    </div>
  </div>
  <div class="peek-subline" *ngIf="subline()">{{ subline() }}</div>
</div>

<!-- Stats come directly under the header: the tabs region below grows to
     fill the panel (its panels scroll internally), so anything placed after
     it would be pushed to the bottom of the panel. -->
<div class="peek-stats" *ngIf="hasStats()">
  <div
    class="peek-stat"
    *ngFor="let stat of stats(); trackBy: trackByStatLabel"
  >
    <span class="label">{{ stat.label | translate }}</span>
    <span
      class="peek-stat-value"
      [class.peek-stat-value-emphasis]="stat.emphasis"
      >{{ stat.value }}</span
    >
  </div>
</div>

<div class="peek-tabs">
  <ng-content select="[peekTabs]"></ng-content>
</div>

<div class="peek-body">
  <ng-content></ng-content>
</div>

<div class="peek-footer" *ngIf="hasFooter()">
  <div class="peek-footer-actions">
    <sh-action-bar
      [primaryAction]="primaryAction()"
      [secondaryActions]="secondaryActions()"
      [overflowActions]="overflowActions()"
    ></sh-action-bar>
  </div>
  <!-- Users look for "open in full" at the bottom too: when the panel can
       expand, a "More details" button takes the hint's place (it does the
       same as the expand button in the header). -->
  <sh-button
    *ngIf="expandable(); else hint"
    type="button"
    variant="text"
    label="shell.peek.moreDetails"
    icon="pi pi-window-maximize"
    iconPos="right"
    (click)="expand.emit()"
  ></sh-button>
  <ng-template #hint>
    <span class="peek-hint" *ngIf="keyboardHint()">{{
      'shell.peek.keyboardHint' | translate
    }}</span>
  </ng-template>
</div>
